import { useGateValue } from '@statsig/react-bindings';

export enum Flags {
  NEW_COUNTRY_SELECTOR = 'new_country_selector',
  USER_ACCESS_PROFILE = 'user_access_profile',
  SIGNUP_NEW_PRODUCT_SELECTOR = 'signup_new_product_selector',
  HUB_NEW_PRODUCT_SELECTOR = 'hub_new_product_selector',
  BILLING_TRANSITION = 'billing_transition',
}

export const useFlag = (key: Flags): boolean => {
  return useGateValue(key);
};
